<div id="terms-result" class="box bg-white shadow-strong" @Container @Grow *ngIf="focus && value !== '' && (error$ | async) === false">
    <ng-container *ngIf="(loading$ | async) === false; else loader">
        <ng-container *ngIf="terms !== undefined && terms.length > 0; else notFound">
            <div @Grow role="listbox">
                <p
                    (click)="onTermClick($event, term)"
                    (enterKeyUp)="onTermEnter(term)"
                    (focus)="onTermFocus(term)"
                    [attr.aria-selected]="focusedTerm === term"
                    tabindex="0"
                    #dropdownItem
                    [id]="term"
                    role="option"
                    *ngFor="let term of terms; let index = index"
                >
                    {{ term }}
                </p>
            </div>
        </ng-container>
    </ng-container>
</div>

<ng-template #loader>
    <div @Grow [style.height.rem]="6">
        <app-loader loaderType="cover" overlayColor="white"></app-loader>
    </div>
</ng-template>

<ng-template #notFound>
    <div @Grow class="not-found text-center">{{ 'v3-explore-no-results-found' | translate }}</div>
</ng-template>
